import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.sys.production,
  name: sharedEnvironment.sys.name,
  ansokanUrl: sharedEnvironment.sys.ansokanUrl,
  bpUrl: sharedEnvironment.sys.bpUrl,
  etjansterCommonUrl: sharedEnvironment.sys.etjansterCommonUrl,
  cookieDomain: sharedEnvironment.sys.cookieDomain,
  ansokanApiUrl: `${sharedEnvironment.sys.gatewayUrl}/ansok`,
  featureUrl: `${sharedEnvironment.sys.gatewayUrl}/ansok/feature`,
  ansokanSignalRUrl: `${sharedEnvironment.sys.gatewayUrl}/ansok`,
  etjansterCommonApiUrl: `${sharedEnvironment.sys.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring/ansokan`,
  sprakHanteringApiUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.sys.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.sys.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.sys.projektUrl,
  chatbotApiUrl: `${sharedEnvironment.sys.gatewayUrl}/ansok/chatbot`,
  externalLinks: sharedEnvironment.sys.externalLinks,
  baseGatewayUrl: sharedEnvironment.sys.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.sys.apimSubscriptionKey,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      `${sharedEnvironment.sys.gatewayUrl}/ansok`,
      sharedEnvironment.sys.azureAdB2C.clientId.ansokanClientId,
      sharedEnvironment.sys.azureAdB2C.clientId.ansokanApiClientId,
    ),
    authority: sharedEnvironment.sys.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.sys.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.sys.azureAdB2C.clientId.ansokanApiClientId}/all`,
    tenant: sharedEnvironment.sys.azureAdB2C.tenant,
    policies: sharedEnvironment.sys.azureAdB2C.policies,
    clientId: sharedEnvironment.sys.azureAdB2C.clientId,
  },
  ga4MeasurementId: sharedEnvironment.sys.ga4MeasurementId,
};
